import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { EspTokenResolverService } from '../services/esp-auth.service';
import { TechnadoptTokenResolverGuard } from './technadopt-token-resolver-guard.service';
import { simpleStrataTokenResolverGuard } from './simpleStrata-token-resolver-guard.service';
import { engagementProTokenResolverService as engproTokenResolver, oppProTokenResolverService, SimpleStrataTokenResolverService } from '../services/simplestrata-auth.service';
import { HigherTokenResolverService } from '../services/higher-auth.service';
import { OpportunityProTokenResolverService } from 'src/app/opporunity/opportunity.service';
import { EngagementProTokenResolverService } from 'src/app/engagement/engagementpro.service';
import { GroupsService } from 'src/app/groups/groups.service';
import { SignInProposeService } from '../modals/signin-propose/signin-propose.service';
import { PlannexeResolverService } from '@plannexe/shared/services/auth.service';
@Injectable({ providedIn: 'root' })
export class AuthGuard  {
  constructor(private auth: AuthService, private router: Router,
    private groupsService: GroupsService,
    private _signInProposeService: SignInProposeService,
    private _espTokenResolver: EspTokenResolverService,
    private _technadoptResolver: TechnadoptTokenResolverGuard,
    private _simpleStrataResolver: simpleStrataTokenResolverGuard,
    private _engProResolver: engproTokenResolver,
    private _ssResolver: SimpleStrataTokenResolverService,
    private _oppProResolver: oppProTokenResolverService,
    private _higherResolver: HigherTokenResolverService,
    private _plannexeTokenResolver: PlannexeResolverService,
    private _opportunityProTokenResolver: OpportunityProTokenResolverService,
    private _engagementProTokenResolver: EngagementProTokenResolverService) {
  }

  canLoad(route: Route, segments: UrlSegment[]): Promise<boolean> {
    if (!this.auth.isLoggedIn()) {
      this.router.navigate(['/auth/login']);
      return Promise.resolve(false);
    }
    return Promise.resolve(true);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    if (!this.auth.isLoggedIn()) {
      this.router.navigate(['/auth/login']);
      if (route.queryParams['source'] == 'connectexe' ||
        route.queryParams['source'] == 'plannexe') {
        this.setRedirectPath(state.url)
      }
      return Promise.resolve(false);
    }
    // this._resolveClientTokens();
    return Promise.resolve(true);
  }


  private _resolveClientTokens() {
    this._espTokenResolver.resolve().subscribe();
    this._technadoptResolver.resolve(null, null).subscribe(res => { console.log(res) });
    // this._simpleStrataResolver.resolve(null, null).subscribe();
    this._engProResolver.resolve().subscribe();
    // this._ssResolver.resolve().subscribe();
    this._oppProResolver.resolve().subscribe();
    this._higherResolver.resolve().subscribe();
    // this._plannexeTokenResolver.resolve().subscribe();
    //this._opportunityProTokenResolver.resolve().subscribe();
    this._engagementProTokenResolver.resolve().subscribe();
  }

  private setRedirectPath(url) {
    this.groupsService.setGoBackUrl('/auth/login');
    this._signInProposeService.setRedirectPath(url);
  }
}
